module.exports = function (obj) {
  var prop;

  for (prop in obj) {
    if (obj.hasOwnProperty(prop)) {
      return false;
    }
  }
  return true;
};



/*****************
 ** WEBPACK FOOTER
 ** ./packages/cssx/src/helpers/isEmpty.js
 ** module id = 15
 ** module chunks = 0
 **/